<template>
  <!-- TASK-SF-07 -- DESIGN-04, onboarding step 1 of 3 (identity). -->
  <form
    class="step-identity"
    @submit.prevent="onNext"
    data-testid="step-identity"
  >
    <p class="onboarding-eyebrow" data-testid="onboarding-eyebrow">
      {{ $t('login.studentOnboarding.eyebrow') }}
    </p>
    <h1 ref="heading" tabindex="-1" class="uc-form-header">
      {{ $t('login.studentOnboarding.step1.heading') }}
    </h1>
    <p class="uc-form-lead">{{ $t('login.studentOnboarding.step1.lead') }}</p>

    <div class="uc-form-element">
      <label for="onboardingFirstName" class="uc-form-label">{{
        $t('login.studentOnboarding.step1.firstNameLabel')
      }}</label>
      <input
        id="onboardingFirstName"
        class="uc-form-text-input"
        type="text"
        autocomplete="given-name"
        data-testid="onboarding-first-name"
        :value="value.firstName"
        @input="update('firstName', $event.target.value)"
      />
    </div>

    <div class="uc-form-element">
      <label for="onboardingLastName" class="uc-form-label">
        {{ $t('login.studentOnboarding.step1.lastNameLabel') }}
        <span
          class="onboarding-optional-marker"
          data-testid="onboarding-last-name-optional"
          >{{ $t('login.studentOnboarding.optionalMarker') }}</span
        >
      </label>
      <input
        id="onboardingLastName"
        class="uc-form-text-input"
        type="text"
        autocomplete="family-name"
        data-testid="onboarding-last-name"
        :value="value.lastName"
        @input="update('lastName', $event.target.value)"
      />
    </div>

    <div class="onboarding-actions">
      <button
        type="button"
        class="onboarding-actions__back"
        data-testid="onboarding-step1-back"
        @click="$emit('back')"
      >
        {{ $t('login.studentOnboarding.step1.backButton') }}
      </button>
      <button
        class="uc-form-button"
        type="submit"
        data-testid="onboarding-step1-next"
        :disabled="!canContinue"
      >
        {{ $t('login.studentOnboarding.nextButton') }}
      </button>
    </div>

    <p
      v-if="!canContinue"
      class="onboarding-required-hint"
      role="alert"
      aria-live="polite"
      data-testid="onboarding-required-hint"
    >
      {{ $t('login.studentOnboarding.requiredHint') }}
    </p>
  </form>
</template>

<script>
export default {
  name: 'StepIdentity',
  props: {
    value: {
      type: Object,
      default: () => ({ firstName: '', lastName: '' }),
    },
  },
  computed: {
    // HUMAN DECISION 1: نام خانوادگی is optional. Only نام gates "continue";
    // an empty lastName flows through the existing terminal call as ''.
    canContinue() {
      return !!(this.value.firstName && this.value.firstName.trim())
    },
  },
  mounted() {
    if (this.$refs.heading) this.$refs.heading.focus()
  },
  methods: {
    update(key, val) {
      // Emit only the changed key; the wizard merges it into the fresh form.
      this.$emit('input', { [key]: val })
    },
    onNext() {
      if (this.canContinue) this.$emit('next')
    },
  },
}
</script>
